import { textStyles } from "../../../../theme/foundations/generated";
const ComponentStyle = {
    baseStyle: {
        indicator: {
            h: "6",
            w: "6",
            borderRadius: 0,
            border: "1px solid",
            borderColor: "semantic.interactive.primary",
            "&[data-status=complete]": {
                backgroundColor: "semantic.interactive.primary",
                color: "semantic.surface.1",
            },
            "&[data-status=active]": {
                border: "1px solid",
                borderColor: "semantic.interactive.primary",
                backgroundColor: "semantic.cta.secondaryHover",
                color: "semantic.interactive.primary",
            },
            "&[data-status=incomplete]": {
                border: "1px solid",
                borderColor: "semantic.interactive.primary",
                backgroundColor: "semantic.surface.1",
                color: "semantic.interactive.primary",
            },
        },
        number: Object.assign({}, textStyles.body.smallBold),
        separator: {
            "&[data-orientation=horizontal]": {
                marginInlineStart: 0,
                height: "0.25rem",
            },
            "&[data-status=complete]": {
                backgroundColor: "semantic.interactive.primary",
            },
            "&[data-status=active]": {
                backgroundColor: "semantic.background.disabled",
            },
            "&[data-status=incomplete]": {
                backgroundColor: "semantic.background.disabled",
            },
        },
        step: {
            gap: 0,
            "button.chakra-step__indicator": {
                _hover: {
                    border: "2px solid",
                    borderColor: "semantic.interactive.primary",
                    backgroundColor: "semantic.cta.secondaryHover",
                    color: "semantic.interactive.primary",
                },
                _active: {
                    border: "1px solid",
                    borderColor: "semantic.interactive.primary",
                    backgroundColor: "semantic.cta.secondaryHover",
                    color: "semantic.interactive.primary",
                },
            },
        },
        stepper: {
            gap: 0,
        },
    },
};
export default ComponentStyle;
//# sourceMappingURL=Stepper.default.js.map